import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { ETextType } from '@web/dtos';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import { TextsTableComponent } from '../../../components/data-display/texts-table/texts-table.compent';

@Component({
  selector: 'aw-web-texts-page',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TextsTableComponent,
  ],
  templateUrl: './texts-for-web-page.component.html',
  styles: ``,
})
export class TextsForWebPageComponent {
  protected readonly webTextStore: WebTextStore = inject(WebTextStore);
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
  protected readonly ETextType: typeof ETextType = ETextType;

  @ViewChild('textTable')
  protected readonly textTableRef!: TextsTableComponent;

  get hasChanges(): boolean {
    return this.textTableRef.hasChanges;
  }
}
